module.exports = {
  prodsSale: `
  @page {
    size: A4;
  }
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&family=Roboto:wght@100;300;400;500;700;900&display=swap');
  * {
    box-sizing: border-box;
    font-family: 'Noto Sans TC';
  }
  #preview {
    position: fixed;
    right: 0;
    width: 210mm;
    height: 297mm;
    background-color: #FFFFFF;
    z-index: 100;
    overflow-y: auto;
    padding: 10mm;
    margin-inline: auto;
  }
  :root {
    --fonts11: calc(11mm * 0.4);
    --fonts12: calc(12mm * 0.4);
    --fonts14: calc(14mm * 0.4);
    --fonts16: calc(16mm * 0.4);
    --fonts18: calc(18mm * 0.4);
  }

  .printTitle {
    font-size: var(--fonts18);
    text-align: center;
    margin-inline: auto;
    letter-spacing: .2em;
  }
  .printBody {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  .printCount {
    display: flex;
    border: 1px solid #000000;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 15px;
    font-size: var(--fonts14);
    line-height: 1.8em;
    margin-top: 15px;
  }
  .eachItem {
    border: 1px solid #000000;
    page-break-inside: avoid;
  }
  .eachItem>div {
    display: flex;
    padding-inline: 15px;
    align-items: center;
    justify-content: space-between;
    font-size: var(--fonts14);
    line-height: 2.8em;
    font-weight: 500;
  }
  .eachItem>div:nth-child(1) {
    border-bottom: 1px solid;
    line-height: 2em;
    font-weight: 400;
  }
  .eachItem>div:nth-child(2) {
    line-height: 2em;
    font-size: var(--fonts12);
    color: #FFFFFF;
    background-color: #8C8C8C;
    font-weight: 400;
  }
  `,

  prodsMake: `
  @page {
    size: A4;
  }
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&family=Roboto:wght@100;300;400;500;700;900&display=swap');
  * {
    box-sizing: border-box;
    font-family: 'Noto Sans TC';
  }
  #preview {
    position: fixed;
    right: 0;
    width: 210mm;
    height: 297mm;
    background-color: #FFFFFF;
    z-index: 100;
    overflow-y: auto;
    padding: 10mm;
    margin-inline: auto;
  }
  :root {
    --fonts11: calc(11mm * 0.4);
    --fonts12: calc(12mm * 0.4);
    --fonts14: calc(14mm * 0.4);
    --fonts16: calc(16mm * 0.4);
    --fonts18: calc(18mm * 0.4);
  }

  .printTitle {
    font-size: var(--fonts18);
    text-align: center;
    margin-inline: auto;
    letter-spacing: .2em;
  }
  .printBody {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  .printCount {
    display: flex;
    border: 1px solid #000000;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 15px;
    font-size: var(--fonts14);
    line-height: 1.8em;
    margin-top: 15px;
  }
  .eachItem {
    border: 1px solid #000000;
  }
  .eachItem>div {
    display: flex;
    padding-inline: 15px;
    align-items: center;
    justify-content: space-between;
    font-size: var(--fonts14);
    line-height: 2.8em;
    font-weight: 500;
  }
  .eachItem>div:nth-child(1) {
    border-bottom: 1px solid;
    line-height: 2em;
    font-weight: 400;
  }
  .eachItem>div:nth-child(2) {
    line-height: 2em;
    font-size: var(--fonts12);
    color: #FFFFFF;
    background-color: #8C8C8C;
    font-weight: 400;
  }
  `
}
